import React, { memo } from "react";
import styled from "styled-components";
import { Spin, Modal } from "antd";

import icon_loading from "assets/icon_loading.png";

const Loading = memo(({ className }) => {
  return (
    <Modal
      wrapClassName="modal_loading"
      footer={null}
      closable={false}
      open={true}
      zIndex={200000}
      maskClosable={false}
      bodyStyle={{
        padding: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      style={{ background: "transparent" }}
    >
      <div>
        <Spin
          spinning={true}
          size="large"
          indicator={
            <img
              src={icon_loading}
              alt="loading"
              className="w-20 loading_icon"
            />
          }
        ></Spin>
      </div>
    </Modal>
  );
});

export default styled(Loading)``;
